<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>QUEST</h2>
        <p>
          축적된 노하우와 기술력으로 최적의 솔루션과 서비스를 제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div id="overview" class="subCon inner_box">
        <section class="platform1 caseCon">
          <h3 id="what" class="con_tit">What's AD Secure</h3>

          <div class="img">
            <v-img src="@/assets/img/quest/adsecure/about.png" alt="" />
          </div>

          <!-- 

		<div class="con">
			<p style="font-size: 20px;">
				Conversion 솔루션은 크게 AS-IS 시스템 분석 솔루션, <br />서버 컨버전 솔루션, 데이터베이스 교체 시 컨버전 솔루션, <br />그리고 프로그램 언어 변환 컨버전 솔루션으로 이루어져 있습니다.
			</p>
			<p style="font-size: 20px;">
				Conversion 솔루션의 프로세스 과정은 <br />자원 수집, 자원 분석, 전환 룰 추출 및 등록 <br />그리고 전환 검증 단계로 이루어져 있습니다.
			</p>
		</div> -->

          <div class="H60"></div>
          <h3 id="need" class="con_tit">Why Need AD Secure?</h3>

          <div class="img">
            <v-img src="@/assets/img/quest/adsecure/need.png" alt="" />
          </div>

          <div class="H60"></div>

          <h3 id="strategy" class="con_tit">Strategy of AD Secure</h3>

          <div class="img">
            <v-img src="@/assets/img/quest/adsecure/strategy1.png" alt="" />
          </div>

          <div class="H60"></div>

          <div class="img">
            <v-img src="@/assets/img/quest/adsecure/strategy2.png" alt="" />
          </div>

          <div class="H60"></div>

          <div class="damage">
            <dl>
              <dt>AD 보안 전략</dt>
              <dd>
                <ol>
                  <li>
                    <span>01</span>
                    <em>#1. 가시성 확보</em><br /><br />
                    - 자체 Agent를 통한 데이터 수집<br />
                    - 통합 검색 제공<br />
                  </li>
                  <li>
                    <span>02</span>
                    <em>#2. 위협 예방</em><br /><br />
                    - 데이터 수집 및 정책기반 위협<br />
                    - 정책기반위협을 통한 예방<br />
                    - 사전 탐지를 통한 위협예방 (Kerberos Roasting 공격)<br />
                  </li>
                  <li>
                    <span>03</span>
                    <em>#3 위협에 대한 사전예방 : 보호</em><br /><br />
                    - 알려진 위협이나 회사 보안정책 위반 보호<br />
                    - 보호된 객체 접근 기록정보 제공<br />
                  </li>
                  <li>
                    <span>04</span>
                    <em>#4. 행위기반 실시간 위협 탐지체계</em><br /><br />
                    - 알려진 위협 탐지<br />
                    - 위협가능성 행위 추이 분석<br />
                    - 실시간 위협탐지 사례 - DCShadow<br />
                  </li>
                  <li>
                    <span>05</span>
                    <em>#5. 분석 체계</em><br /><br />
                    - 분석 플랫폼 제공<br />
                    - 주기적인 리포트 이메일 전송<br />
                    - 조건 검색 및 상세검색 조회<br />
                    - SIEM연동<br />
                    - IT Security Search<br />
                  </li>
                </ol>
              </dd>
            </dl>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
